<div class="h-100 d-flex justify-content-center align-items-center">
  <i class="fa" [className]="value ? 'fa-check-circle': 'fa-times-circle'"></i>
</div>
